import { Flex } from "@chakra-ui/react";
import CInput from "../CInput/CInput";
import CSelect from "../CSelect";
import { BidAndOfferType } from "src/api/types";

export default function CommonDepthBidAndOfferForm(props: { styles: any }) {
  const { styles } = props;

  return (
    <>
      <Flex alignItems="center" gap={2} mt={4}>
        <CInput classname={styles.inputField} label="策略名称" name="strategyName" />
      </Flex>
      <Flex>
        <CSelect
          classname={styles.inputField}
          label="方向"
          name="side9"
          description="填入 buy 或者 sell"
          options={Object.keys(BidAndOfferType).map((key) => ({
            value: BidAndOfferType[key],
            label: key, // 枚举的键
          }))}
        />
      </Flex>
      {/* <Flex>
        <CInput
          classname={styles.inputField}
          label="价1的价差比例最小值"
          name="minDiffInPrice9"
          type="number"
          description="20%"
          rightIndicator="%"
        />
      </Flex> */}
      <Flex>
        <CInput
          classname={styles.inputField}
          label="价1的价差比例最大值"
          name="maxDiffInPrice9"
          type="number"
          description="30%"
          rightIndicator="%"
        />
      </Flex>
      <Flex>
        <CInput
          classname={styles.inputField}
          label="下单总金额（U）"
          name="totalBaseAmount9"
          type="number"
          description="总金额（U）"
        />
      </Flex>

      <Flex>
        <CInput classname={styles.inputField} label="每层最小金额" name="minLayerAmount9" type="number" />
      </Flex>
      <Flex>
        <CInput classname={styles.inputField} label="分几层" name="layerNum9" type="number" />
      </Flex>
      <Flex>
        <CInput
          classname={styles.inputField}
          label="盘口跟价参数 %"
          name="priceFollowRate9"
          type="number"
          description="等于0时，跟随当前方向的买一价;大于0时，跟随反方向的卖一价，并乘以某个百分比（xx%）"
        />
      </Flex>
      {/* <Flex>
        <CInput
          classname={styles.inputField}
          label="目标深度"
          name="targetDepth9"
          type="number"
          description="比如1000U"
        />
      </Flex> */}
    </>
  );
}
